<template>
    <AuthLayout :loading="form.processing">
        <template #logo>
            <div class="flex justify-end items-center pb-8 ">
                <AppLogo />
            </div>
        </template>

        <div class="bg-white p-8 rounded-xl shadow-md w-full max-w-lg mx-auto text-center">
            <h2 class="text-2xl font-bold text-gray-800 mb-2">
                Verify your email
            </h2>

            <p class="text-sm text-gray-600 mb-6 leading-relaxed">
                Thanks for signing up! Before getting started, please verify your email address by clicking the link we
                just
                emailed you.
                If you didn’t receive the email, we’ll gladly send you another.
            </p>

            <!-- Show if link was recently resent -->
            <div v-if="verificationLinkSent"
                class="mb-6 font-medium text-sm text-green-600 bg-green-100 border border-green-200 rounded px-4 py-3">
                A new verification link has been sent to your email address.
            </div>

            <!-- Timer display -->
            <div v-if="timer > 0" class="text-sm text-gray-500 mb-4">
                You can resend in <span class="font-semibold text-gray-700">{{ formattedTime }}</span>
            </div>

            <form @submit.prevent="submit">
                <div class="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <JetButton :disabled="form.processing || timer > 0"
                        :class="{ 'opacity-25 cursor-not-allowed': form.processing || timer > 0 }">
                        Resend verification email
                    </JetButton>

                    <inertia-link :href="route('logout')" method="post" as="button"
                        class="text-sm text-gray-600 underline hover:text-gray-900">
                        Logout
                    </inertia-link>
                </div>
            </form>
        </div>
    </AuthLayout>
</template>

<script>
import AuthLayout from '@/Layouts/AuthLayout.vue';
import JetButton from '@/Jetstream/Button';
import AppLogo from '@/Components/AppLogo';

export default {
    components: {
        AuthLayout,
        JetButton,
        AppLogo,
    },

    props: {
        status: String,
        verificationLinkSent: Boolean,
    },

    data() {
        return {
            form: this.$inertia.form(),
            timer: 0, // 10 minutes in seconds
            countdownInterval: null,
        };
    },

    computed: {
        formattedTime() {
            const minutes = Math.floor(this.timer / 60).toString().padStart(2, '0')
            const seconds = (this.timer % 60).toString().padStart(2, '0')
            return `${minutes}:${seconds}`
        },

        verificationLinkSent() {
            return this.status === 'verification-link-sent';
        },
    },

    methods: {
        submit() {
            this.form.post(this.route('verification.send'), {
                onSuccess: () => {
                    const unlockTime = Math.floor(Date.now() / 1000) + 600 // 10 minutes
                    localStorage.setItem('resendUnlockTime', unlockTime)
                    this.setTimer()
                    this.startCountdown()
                }
            })
        },

        setTimer() {
            const now = Math.floor(Date.now() / 1000)
            const unlockTime = parseInt(localStorage.getItem('resendUnlockTime'), 10)
            this.timer = Math.max(unlockTime - now, 0)
        },

        startCountdown() {
            if (this.countdownInterval) clearInterval(this.countdownInterval)

            this.countdownInterval = setInterval(() => {
                this.setTimer()
                if (this.timer <= 0) {
                    clearInterval(this.countdownInterval)
                    this.countdownInterval = null
                }
            }, 1000)
        },
    },
    mounted() {
        this.setTimer()
        if (this.timer > 0) {
            this.startCountdown()
        }
    },
    beforeDestroy() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval)
        }
    },
};
</script>
